import React from "react";

import { Button, Grid } from "@mui/material";
import Modal from "@mui/material/Modal";
import Container from "@mui/material/Container";

import settings from "../../Images/settings.png";
import timer from "../../Images/timer.png";
import BackArrow from "../../Images/backarrow.png";
import plus from "../../Images/plus.png";
import usdt from "../../Images/usdt.png";
import gsx from "../../Images/gsx.png";
import eth from "../../Images/eth.png";

import { AiOutlineDown } from "react-icons/ai";
import { Link } from "react-router-dom";

import Navbar from "../Navbar/Index";
import Footer from "../Footer/Index";
import TokensDialogOne from "../../Components/Dialogs/TokensDialogOne";
import TokensDialogTwo from "../../Components/Dialogs/TokensDialogTwo";

const Importpool = () => {
  // for dialog
  const [opendialog, setOpendialog] = React.useState(false);
  const [useSelectedValue, setSelectedValue] = React.useState("WETH");
  const [useSelectedImg, setSelectedImg] = React.useState(eth);

  const handleClickOpen = () => {
    setOpendialog(true);
  };

  const handleListItemClick = (value) => {
    setOpendialog(false);
    setSelectedImg(value.logoURI);
    setSelectedValue(value.symbol);
  };
  // for dialog

  // for dialog2
  const [opendialog2, setOpendialog2] = React.useState(false);
  const [useSelectedValue2, setSelectedValue2] = React.useState("USDT");
  const [useSelectedImg2, setSelectedImg2] = React.useState(usdt);
  const [useFirstVal, setFirstVal] = React.useState();
  const [useSecondVal, setSecondVal] = React.useState();
  const [useInputSlipage, setInputSlipage] = React.useState("2.0");

  const handleClickOpendialog2 = () => {
    setOpendialog2(true);
  };

  const handleListItemClick2 = (value2) => {
    setOpendialog2(false);
    setSelectedImg2(value2.logoURI);
    setSelectedValue2(value2.symbol);
  };

  // for dialog2
  const [showResults, setShowResults] = React.useState(false);
  const firstInput = (event) => {
    const val = event.target.value;
    setFirstVal(val);
    setShowResults(true);
  };
  const SecondInput = (event) => {
    const val = event.target.value;
    setSecondVal(val);
    setShowResults(true);
  };
  const handleSlipage = (event) => setInputSlipage(event.target.value);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openrec, setOpenrec] = React.useState(false);
  const handleOpenrec = () => setOpenrec(true);
  const handleCloserec = () => setOpenrec(false);

  return (
    <div>
      <Container>
        <Navbar />
        <div className="forheight">
          <Grid container justifyContent="center">
            <Grid xs={12} sm={11} md={6} className="py-5">
              <div className=" pt-sm-3 d-flex justify-content-center">
                <div className="Ray---Connectpage---Card ">
                  <div className="px-3 pt-3 Ray---Connect---Button---border">
                    <Link to="/liquidity">
                      <img
                        className="Ray---Connect---Modal---Addliquidity---BackArrowbutton"
                        alt=""
                        src={BackArrow}
                      />
                    </Link>
                    <div className="Ray__Connect__Exchange ">
                      Import Pool
                      <p className="Ray---connect---swap">
                        Import An Existing Pool
                      </p>
                    </div>

                    <div className="Ray__Connect__Icons pt-sm-3">
                      <img onClick={handleOpen} alt="" src={settings} />
                      <img
                        className="ml-2"
                        onClick={handleOpenrec}
                        alt=""
                        src={timer}
                      />
                    </div>
                  </div>
                  <TokensDialogOne
                    open={opendialog}
                    onClose={handleListItemClick}
                    disabling={useSelectedValue}
                  />
                  <div className="p-3">
                    <div className="inputfield">
                      <input
                        onChange={firstInput}
                        className="Ray---Connect---Modal---SelectToken---Fieldforsearchtest"
                        type="number"
                        placeholder="0.00"
                        value={useFirstVal}
                      />
                      <a className="alink" onClick={handleClickOpen}>
                        <img
                          className="Ray---Exchange---Dialoglogo"
                          src={useSelectedImg}
                        />
                        {useSelectedValue}
                        <span style={{padding:"0px 0px 0px 8px"}}>
                            <AiOutlineDown />
                            </span>
                      </a>
                    </div>

                    <div className="Ray---Connect---Swapbutton">
                      <img alt="" src={plus} />
                    </div>
                    <TokensDialogTwo
                      opendialog2={opendialog2}
                      onClosedialog2={handleListItemClick2}
                      disablingtoken={useSelectedValue2}
                    />
                    <div className="inputfield">
                      <input
                        onChange={SecondInput}
                        className="Ray---Connect---Modal---SelectToken---Fieldforsearchtest"
                        type="number"
                        placeholder="0.00"
                        value={useSecondVal}
                      />
                      <a className="alink" onClick={handleClickOpendialog2}>
                        <img
                          className="Ray---Exchange---Dialoglogo"
                          src={useSelectedImg2}
                        />
                        {useSelectedValue2}
                        <span style={{padding:"0px 0px 0px 8px"}}>
                            <AiOutlineDown />
                            </span>
                      </a>
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        fontWeight: 200,
                        paddingTop: 20,
                        textAlign: "center",
                      }}
                    >
                      <p>You Don't Have Liquidity In This Pool Yet.</p>
                    </div>
                    <Link style={{ textDecoration: "none" }} to="/supply">
                      <Button className="mt-2 Rey---Connect---SwapButton">
                        Add liquidity
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
        <Footer />

        {/* Modal for settings starts here------------------------------------------ */}

        <Modal
          className="Modal"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                Setting
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleClose(false)}
                >
                  X
                </button>
              </h4>
              <div
                className="Ray---Connect---Modal---fromto"
                style={{ color: "white" }}
              >
                <p>Slipage Tolerance?</p>
                <div className="Ray---settings---inputauto">
                  <Button className="Rey---settings---autobutton">auto</Button>

                  <label htmlFor="text"></label>
                  <input
                    onChange={handleSlipage}
                    className="Ray---Connect---Modal---Text "
                    type="number"
                    placeholder="2.00%"
                    value={useInputSlipage}
                  />
                </div>
                <p className="mt-2 pb-2">Transaction Deadline?</p>

                <p className="Ray---Connect---Modal---TextTransaction"> 20</p>
                <p className="Ray---Connect---Modal---textmint">Minutes</p>
              </div>
            </div>
          </div>
        </Modal>

        {/* Modal for recent starts here -----------------------------------------*/}
        <Modal
          className="Modal"
          open={openrec}
          onCloserec={handleCloserec}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                Recent Transactions
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleCloserec(false)}
                >
                  X
                </button>
              </h4>

              <div
                style={{ color: "white" }}
                className="Rey---Head---card---ModalRecentboxcolor"
              >
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <h6>Send</h6>
                  <h6>-50 Gxs</h6>
                </div>
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <span>Jan 10 To: 0X024...1E61</span>
                  <span> +50 Gxs</span>
                </div>
              </div>
              <div
                style={{ color: "white" }}
                className="Rey---Head---card---ModalRecent2ndboxcolor"
              >
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <h6>Recieved</h6>
                  <h6> +500 Gxs</h6>
                </div>
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <span>Jan 10 To: 0X024...1E61</span>
                  <span> +500 Gxs</span>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        {/* modal for recent ends ------------------------------------------*/}
      </Container>
    </div>
  );
};
export default Importpool;
